import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
// @mui
import { Box, Stack, Button, Typography, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
// assets


// ----------------------------------------------------------------------

const StyledDropZone = styled('div')(({ theme }) => ({
    outline: 'none',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    padding: theme.spacing(1),
    '&:hover': {
        opacity: 0.72,
    },
}));

// ----------------------------------------------------------------------

Upload.propTypes = {
    sx: PropTypes.object,
    error: PropTypes.bool,
    files: PropTypes.array,
    file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    onDelete: PropTypes.func,
    onRemove: PropTypes.func,
    onUpload: PropTypes.func,
    thumbnail: PropTypes.bool,
    helperText: PropTypes.node,
    onRemoveAll: PropTypes.func,
    patchFileName:  PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

};

export default function Upload({
    disabled,
    multiple = false,
    error,
    helperText,
    //
    file,
    onDelete,
    //
    files,
    thumbnail,
    onUpload,
    onRemove,
    onRemoveAll,
    patchFileName,
    sx,
    ...other
}) {
    const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
        multiple,
        disabled,
        ...other,
    });

    const hasFile = !!file && !multiple;

    const isError = isDragReject || !!error;

    return (
        <Box sx={{ position: 'relative', ...sx }}>
            <StyledDropZone
                {...getRootProps()}
                sx={{
                    ...(isDragActive && {
                        opacity: 0.72,
                    }),
                    ...(isError && {
                        color: 'error.main',
                        borderColor: 'error.light',
                    }),
                    ...(disabled && {
                        opacity: 0.48,
                        pointerEvents: 'none',
                    }),
                    ...(hasFile && {
                        padding: '12% 0',
                    }),
                }}
            >
                <input {...getInputProps()} />
                <Stack direction="row" spacing={3} >
                <Placeholder
                    sx={{
                        ...(hasFile && {
                            opacity: 0,
                        }),
                    }}

                />
                    {patchFileName ? (
                        <Tooltip title={patchFileName}>

                            <Typography variant="subtitle2" sx={{ fontWeight: 900, wordBreak: 'break-all', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', pt: 1, width: { xs: 70, md: (patchFileName.length*10) }}}>
                        {patchFileName}
                            </Typography>
                        </Tooltip>
                            
                    ) : (
                            <Tooltip title="No File Uploaded">
                            <Typography variant="caption" fontSize="14px" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', pt: 1, width: { xs:70 ,md:110} }}>
                        No file uploaded
                                </Typography>
                                </Tooltip>

                )}

                    </Stack>

            </StyledDropZone>

            {helperText && helperText}

           
        </Box>
    );
}

// ----------------------------------------------------------------------

Placeholder.propTypes = {
    sx: PropTypes.object,

};

function Placeholder({ sx, ...other}) {
    return (
        <Stack
            spacing={1}
            alignItems="left"
            justifyContent="left"
            direction={{
                xs: 'column',
                md: 'row',
            }}
            sx={{
                
                textAlign: {
                    xs: 'center',
                    md: 'left',
                },
                ...sx,
            }}
            {...other}
        >

            <Button variant="outlined" component="label" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                Browse files 
            </Button>
        </Stack>
    );
}
